/**
 * 20 px initials avatar for list tables (§9-D).
 * Background is picked from the 8-colour pastel palette (§9-D / index.css .ggj-avatar-*),
 * hashed deterministically from the name string.
 */

function hashName(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h + str.charCodeAt(i)) >>> 0;
  }
  return h;
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

interface TableAvatarProps {
  /** Display name — used for initials and colour hash. */
  name: string;
  /** Pixel size. Defaults to 20. */
  size?: number;
  /** Optional photo URL; falls back to initials. */
  src?: string | null;
}

export function TableAvatar({ name, size = 20, src }: TableAvatarProps) {
  const paletteIdx = hashName(name) % 8;
  const fontSize = Math.round(size * 0.42);

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        width={size}
        height={size}
        className="rounded-full object-cover shrink-0"
        style={{ width: size, height: size }}
        onError={(e) => {
          (e.currentTarget as HTMLImageElement).style.display = 'none';
        }}
      />
    );
  }

  return (
    <span
      className={`ggj-avatar-${paletteIdx} inline-flex items-center justify-center rounded-full font-semibold shrink-0 select-none`}
      style={{ width: size, height: size, fontSize }}
      aria-hidden
    >
      {getInitials(name)}
    </span>
  );
}
